<template>
    <v-dialog
        v-model="dialog"
        :max-width="width"
        :fullscreen="!noFullscreen && $vuetify.breakpoint.xsOnly"
        :persistent="persistent"
        scrollable
    >
        <v-card>
            <v-card-title class="text-h6 d-flex flex-nowrap align-start">
                <div class="flex-grow-1 text-truncate t-heading-medium">Confirmar senha</div>
            </v-card-title>

            <v-card-text>

                <div class="t-body my-5">
                    Para realizar essa ação é necessário confirmar sua senha:
                </div>

                <v-text-field
                    label="Senha"
                    v-model="password"
                    outlined
                    dense
                    required
                    :append-icon="showPass ? '$eye' : '$eyeOff'"
                    :type="showPass ? 'text' : 'password'"
                    @click:append="showPass = !showPass"
                    @keyup.enter="confirm"
                ></v-text-field>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <cp-button
                    color="success"
                    :disabled="saving"
                    :loading="saving"
                    @click="confirm"
                >
                    Confirmar
                </cp-button>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data: () => ({
            dialog: false,
            size: null,
            persistent: true,
            noFullscreen: false,
            password: null,
            showPass: false,
            callback: {},
            saving: false
        }),
        methods: {
            open(config = {}) {
                const {
                    size = null,
                    persistent = true,
                    noFullscreen = false,
                    callback = {}
                } = config

                if (!callback) {
                    throw 'required callback'
                }

                this.size = size
                this.persistent = persistent
                this.noFullscreen = noFullscreen
                this.callback = callback

                this.dialog = true
            },
            close() {
                this.dialog = false
            },
            confirm() {
                this.saving = true;

                axios.post(this.route('password.confirm.store'), {
                    password: this.password
                })
                .then((res) => {
                    if (res.status == 201) {
                        this.close()
                        this.callback()
                    }

                }).catch((error) => {
                    if (this.errorFeedback(error) == 422) {
                        console.log(error.response.data.errors);
                    }
                }).finally(() => {
                    this.saving = false;
                })
            },
        },
        computed: {
            width() {
                switch (this.size) {
                case 'small':
                    return '290'
                case 'large':
                    return '800'
                default:
                    return '500'
                }
            },
        },
    }
</script>

<style scoped lang="scss">
$border: 1px solid var(--v-neutral-2-base);

.v-card {
    background-color: var(--v-white-base);
    border: $border;
    border-radius: 2px;

    .v-card__title {
        background-color: var(--v-neutral-1-base);
        border-bottom: $border;
        height: 48px;
        padding: 14px 16px 0px;

        .v-btn--icon {
            margin-top: -3px;
        }
    }
    .v-card__actions {
        background-color: var(--v-neutral-1-base);
        border-top: $border;
    }
}
</style>
